import { render } from "./WhereToBuyAccess.vue?vue&type=template&id=5668ac7a"
import script from "./WhereToBuyAccess.vue?vue&type=script&lang=js"
export * from "./WhereToBuyAccess.vue?vue&type=script&lang=js"

import "./WhereToBuyAccess.vue?vue&type=style&index=0&id=5668ac7a&lang=scss"

import exportComponent from "D:\\Megais_Allie\\@202307\\02_十六茶_中秋序號活動\\16cha\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__